import {
    Globe, Facebook, Instagram, Linkedin, Github, Youtube, Twitter, Send, MessageCircle, Music2,
} from 'lucide-react';

// HexLink mark (hexagon with link node).
export function HexMark(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" {...props}>
            <path d="M12 2.5 20.5 7.25v9.5L12 21.5 3.5 16.75v-9.5L12 2.5Z" />
            <circle cx="12" cy="12" r="2.6" fill="currentColor" stroke="none" />
        </svg>
    );
}

export function CheckBadge(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" {...props}>
            <path d="m5 12.5 4.5 4.5L19 7.5" />
        </svg>
    );
}

export const SOCIALS = {
    linkedin: { label: 'LinkedIn', Icon: Linkedin, url: (v) => v },
    instagram: { label: 'Instagram', Icon: Instagram, url: (v) => v },
    facebook: { label: 'Facebook', Icon: Facebook, url: (v) => v },
    twitter: { label: 'X', Icon: Twitter, url: (v) => v },
    x: { label: 'X', Icon: Twitter, url: (v) => v },
    tiktok: { label: 'TikTok', Icon: Music2, url: (v) => v },
    youtube: { label: 'YouTube', Icon: Youtube, url: (v) => v },
    github: { label: 'GitHub', Icon: Github, url: (v) => v },
    whatsapp: {
        label: 'WhatsApp',
        Icon: MessageCircle,
        // Bare numbers become wa.me links.
        url: (v) => (/^\+?[\d\s()-]+$/.test(v) ? `https://wa.me/${v.replace(/\D/g, '')}` : v),
    },
    telegram: {
        label: 'Telegram',
        Icon: Send,
        url: (v) => (/^@?\w+$/.test(v) ? `https://t.me/${v.replace(/^@/, '')}` : v),
    },
    website: { label: 'Website', Icon: Globe, url: (v) => v },
};

// Show a handle instead of a full URL where we can.
export function socialHandle(platform, url) {
    try {
        const u = new URL(/^https?:\/\//i.test(url) ? url : `https://${url}`);
        const path = u.pathname.replace(/\/+$/, '').split('/').filter(Boolean);
        if (platform === 'website') return u.hostname.replace(/^www\./, '');
        if (path.length) {
            const last = path[path.length - 1];
            return last.startsWith('@') ? last : `@${last}`;
        }
        return u.hostname.replace(/^www\./, '');
    } catch {
        return url;
    }
}
